module.exports = __webpack_public_path__ + "img/hest7.acf35804.jpg";